import {
  ABORT,
  AD_ENDED,
  AD_ERROR,
  AD_START,
  ALL_ADS_COMPLETED,
  CAN_PLAY,
  CAN_PLAY_THROUGH,
  DURATION_CHANGE,
  EMPTIED,
  END,
  END_SEEKING,
  ERROR,
  LOAD_START,
  LOADED_DATA,
  LOADED_LEVELS,
  LOADED_META_DATA,
  MANIFEST_PARSED,
  MEDIA_LATENCY_CHANGE,
  MEDIA_STATE_CHANGE,
  PAUSE,
  PLAY,
  PLAYING,
  PROGRESS_CHANGE,
  RATE_CHANGE,
  REAL_TRACK_CHANGE,
  RESIZE,
  SEEKED,
  SEEKING,
  SEEKING_TIME,
  STALLED,
  SUSPEND,
  TIME_UPDATE,
  TRACK_CHANGE,
  VOLUME_CHANGE,
  WAITING,
  CONTENT_LOADING_STARTED,
  CONTENT_LOADING_ENDED,
} from '../actions/video';
import {
  AUDIO_ONLY_CHANGE,
  FULLSCREEN_CHANGE,
  PLAYER_ACTIVATE,
  USER_ACTIVATE
} from '../actions/player';

const initialState = {
  currentSrc: null,
  duration: 0,
  currentTime: 0,
  seekingTime: 0,
  buffered: null,
  waiting: false,
  seeking: false,
  paused: true,
  autoPaused: false,
  ended: false,
  playbackRate: 1,
  muted: false,
  volume: 1,
  isLive: false,
  hasDVR: false,
  liveTime: 0,
  latency: 0,
  activeTrack: -1,
  realActiveTrack: -1,
  switchingTrack: false,
  tracks: [],
  readyState: 0,
  networkState: 0,
  videoWidth: 0,
  videoHeight: 0,
  hasStarted: false,
  userActivity: true,
  isActive: false,
  isFullscreen: false,
  hls: null,
  secondsPlayed: 0,
  percentPlayed: 0,
  waitingTime: 0,
  delayToStartPlaying: 0,
  waitingDuration: 0,
  audioOnly: false,
  mediaDuration: 0,
  playOffset: 0,
  controlsVisibility: true,
  contentLoading: true,
};

export function player(state = initialState, action) {
  switch (action.type) {
    case USER_ACTIVATE:
      return {
        ...state,
        userActivity: action.activity
      };
    case PLAYER_ACTIVATE:
      return {
        ...state,
        isActive: action.activity
      };
    case FULLSCREEN_CHANGE:
      return {
        ...state,
        isFullscreen: !!action.isFullscreen
      };
    case AUDIO_ONLY_CHANGE:
      return {
        ...state,
        audioOnly: action.audioOnly
      };
    case AD_START:
      return {
        ...state,
        ads: true
      };
    case AD_ENDED:
      return {
        ...state,
        ads: false
      };
    case CONTENT_LOADING_STARTED:
      return {
        ...state,
        contentLoading: true
      };
    case CONTENT_LOADING_ENDED:
      return {
        ...state,
        contentLoading: false
      };
    case AD_ERROR:
    case ALL_ADS_COMPLETED:
      return {
        ...state,
      };
    case SEEKING_TIME:
      return {
        ...state,
        seekingTime: action.time
      };
    case END_SEEKING:
      return {
        ...state,
        seekingTime: 0
      };
    case LOAD_START:
      return {
        ...state,
        ...action.videoProps,
        hasStarted: false,
        ended: false
      };
    case CAN_PLAY_THROUGH:
      const newStateCanPlayThrough = {
        ...state,
        ...action.videoProps
      };
      if (action.videoProps.paused === true) {
        // newStateCanPlayThrough.hasStarted = true;
        newStateCanPlayThrough.waiting = false;
      }
      return newStateCanPlayThrough;
    case CAN_PLAY:
      const newStateCanPlay = {
        ...state,
        ...action.videoProps,
        waitingDuration: action.waitingDuration,
        delayToStartPlaying: action.delayToStartPlaying
      };
      if (action.videoProps.paused === true) {
        // newStateCanPlay.hasStarted = true;
        newStateCanPlay.waiting = false;
      }
      return newStateCanPlay;
    case WAITING:
      return {
        ...state,
        ...action.videoProps,
        waiting: true
      };
    case PLAYING:
      return {
        ...state,
        ...action.videoProps,
        waiting: false,
        hasStarted: true,
      };
    case PLAY:
      return {
        ...state,
        ...action.videoProps,
        ended: false,
        paused: false,
        autoPaused: false,
        waiting: false,
        // hasStarted: true,
      };
    case PAUSE:
      return {
        ...state,
        ...action.videoProps,
        paused: true
      };
    case END:
      return {
        ...state,
        ...action.videoProps,
        ended: true
      };
    case SEEKING:
      return {
        ...state,
        ...action.videoProps,
        seeking: true
      };
    case SEEKED:
      return {
        ...state,
        ...action.videoProps,
        seeking: false
      };
    case ERROR:
      return {
        ...state,
        ...action.videoProps,
        error: 'UNKNOWN ERROR',
        ended: true
      };
    case MEDIA_STATE_CHANGE:
      return {
        ...state,
        hasDVR: action.hasDVR,
        isLive: action.isLive,
        mediaDuration: action.mediaDuration,
        playOffset: action.playOffset
      };
    case MEDIA_LATENCY_CHANGE:
      return {
        ...state,
        liveTime: action.liveTime,
        latency: action.latency
      };
    case LOADED_LEVELS:
      return {
        ...state,
        tracks: action.tracks
      };
    case MANIFEST_PARSED:
      return {
        ...state,
        hls: action.hls
      };
    case TRACK_CHANGE:
      return {
        ...state,
        activeTrack: action.activeTrack
      };
    case REAL_TRACK_CHANGE:
      return {
        ...state,
        realActiveTrack: action.realActiveTrack,
        switchingTrack: action.switchingTrack
      };
    case TIME_UPDATE:
      return {
        ...state,
        ...action.videoProps,
        secondsPlayed: action.secondsPlayed,
        percentPlayed: action.percentPlayed,
        waitingTime: action.waitingTime,
        waiting: false
      };
    case DURATION_CHANGE:
    case VOLUME_CHANGE:
    case PROGRESS_CHANGE:
    case RATE_CHANGE:
      return {
        ...state,
        ...action.videoProps
      };
    case SUSPEND:
    case ABORT:
    case EMPTIED:
    case STALLED:
    case LOADED_META_DATA:
    case LOADED_DATA:
    case RESIZE:
      return {
        ...state,
        ...action.videoProps
      };
    default:
      return state;
  }
}

export default player;
